import updateNextSearchQueryId from '../actions/updateNextSearchQueryId';
import getScenarioStore from '../store/getScenarioStore';
import { getGuid } from 'owa-guid';
import { mutator } from 'satcheljs';

mutator(updateNextSearchQueryId, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).nextSearchQueryId = getGuid();
});
